/**
 * Generates a sufficient unique id string. Not suitable for cryptographic purposes.
 * It can be used to distinguish elements and pass the created string to id or key attributes/properties.
 *
 * @return {string} A unique id
 */
function uniqueId() {
    const now = (typeof performance !== 'undefined' && performance.now()) || Date.now()
    return (Math.random() * now).toString(16)
}

export { uniqueId }
